import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Banner from "../components/banner"
import Section from "../components/section"
import Title from "../components/title"

import bannerPng from "../images/join/banner.png"
import introductionPng from "../images/join/introduction.png"
import jobPng from "../images/join/job.png"

const Page = () => {
  return (
    <Layout>
      <SEO title="加入我们" />
      <Banner image={bannerPng} />
      <Section style={{ paddingTop: 30 }}>
        <div style={styles.job}>
          招聘岗位：销售经理/Java开发工程师/测试工程师/运维工程师
        </div>
        <Title name="了解我们" />
        <div>
          <img src={introductionPng} alt="招聘-公司介绍及福利" />
        </div>
        <Title name="岗位需求" />
        <div style={styles.jobWrap}>
          <img src={jobPng} alt="招聘-岗位" />
        </div>
      </Section>
    </Layout>
  )
}

const styles = {
  job: {
    background: "#367fc3",
    color: "#fff",
    padding: "8px 10px",
    borderRadius: 3,
    fontWeight: 600,
  },
  jobWrap: {
    marginBottom: 40,
  },
}

export default Page
